import React from 'react'
import Link, { navigateTo } from 'gatsby-link'

import fields from '../data/FieldDefinitions'
import bezirke from '../data/bezirke'
import Atlas from '../container/Atlas'
import Legend from '../components/Legend'
import Popup from '../components/Popup.js'
import Quelle from '../components/Quelle.js'
import * as topojson from 'topojson-client'

import calculateVIFKategorie from '../helpers/calculateVIFKategorie'
import YearChange from '../components/YearChange'

class Criteria extends React.Component {
  constructor(props) {
    super(props)
    this.state = { zoomToIso: null, popup: null, showKoop: true }
  }

  clickOnGemeinde = iso => {
    const bezirk = bezirke.find(b => b.filter(iso))
    this.setZoomToIso(bezirk.zoomToIso)
    this.openPopup(iso)
  }

  setYearSuffix = suffix => {
    const pathname = this.props.location.pathname
    const pathnameWithoutSuffix = pathname.substr(
      0,
      pathname.length - this.props.pathContext.suffix.length
    )
    const newPathname = `${pathnameWithoutSuffix}${suffix}`
    navigateTo(newPathname)
  }

  setZoomToIso = iso => {
    this.setState({ zoomToIso: iso })
  }

  closePopup = () => {
    this.setState({ popup: null })
  }

  openPopup = iso => {
    const data = {
      gemeinde: this.props.data.gemeinden.edges.find(e => e.node.iso == iso)
        .node,
      betriebe: {
        edges: this.props.data.betriebe.edges.filter(e => e.node.GEMNR == iso),
      },
      zusatzGemeinden: {
        edges: this.props.data.zusatzGemeinden.edges.filter(
          e => e.node.Code_2015 == iso
        ),
      },
      zusatzBetriebe: {
        edges: this.props.data.zusatzBetriebe.edges.filter(
          e => e.node.GEMNR == iso
        ),
      },
      kooperationen: {
        edges: this.props.data.kooperationen.edges,
      },
      alleGemeinden: {
        edges: this.props.data.gemeinden.edges,
      },
    }
    this.setState({ data, popup: iso })
  }

  overlay = ({ map, pathGenerator }) => {
    function addToKooperationen(acc, d, key) {
      if (d[key]) {
        if (acc[d[key]]) {
          acc[d[key]].push(d.iso)
        } else {
          acc[d[key]] = [d[key], d.iso]
        }
      }
    }

    const kooperationen = this.props.data.kooperationen.edges.reduce(
      (acc, d) => {
        fields[this.props.pathContext.dataField].kooperationen.forEach(k => {
          addToKooperationen(acc, d.node, k)
        })
        return acc
      },
      {}
    )

    const overlay = Object.values(kooperationen).map((b, i) => {
      const d = topojson.merge(
        map,
        map.objects.gemeinden.geometries.filter(g =>
          b.includes(parseInt(g.properties.iso))
        )
      )

      return <path key={`path_${i}`} d={pathGenerator(d)} />
    })

    return <g className="kooperationen">{overlay}</g>
  }

  overlayDataWithKooperationen(originalData) {
    const iso = originalData.iso

    let data = { ...originalData }

    const fieldDefinition = fields[this.props.pathContext.dataField]

    const kooperationen = this.props.data.kooperationen.edges.find(
      d => d.node.iso === iso
    ).node

    fieldDefinition.kooperationen.forEach(k => {
      if (kooperationen[k]) {
        const kooperationsGemeinde = this.props.data.gemeinden.edges.find(
          d => d.node.iso === kooperationen[k]
        )

        if (kooperationsGemeinde) {
          if (k === 'koop_3_6J_GEM')
            data['VIF_3_6'] = kooperationsGemeinde.node['VIF_3_6']
          else if (k === 'koop_u3J_GEM')
            data['VIF_0_3'] = kooperationsGemeinde.node['VIF_0_3']

          Object.entries(fields)
            .filter(
              ([field, definition]) =>
                definition.kooperationen.length === 1 &&
                definition.kooperationen.includes(k)
            )
            .forEach(([field, definition]) => {
              data[field] = kooperationsGemeinde.node[field]
            })
        }
      }
    })

    if (this.props.pathContext.dataField === 'VIF_Kategorie') {
      data.VIF_Kategorie = calculateVIFKategorie(data)
    }

    return data
  }

  getData = iso => {
    const data = this.props.data.gemeinden.edges.find(d => d.node.iso === iso)
      .node

    return this.state.showKoop ? this.overlayDataWithKooperationen(data) : data
  }

  render() {
    console.log('render criteria', this.props.pathContext.year)

    return (
      <div className="content-box">
        <h2>
          {this.props.pathContext.parentTitle
            ? this.props.pathContext.parentTitle
            : this.props.pathContext.title}
          <YearChange
            suffix={this.props.pathContext.suffix}
            setYearSuffix={this.setYearSuffix}
          />
        </h2>
        {this.state.popup ? (
          <Popup
            closePopup={this.closePopup}
            data={this.state.data}
            openPopup={this.openPopup}
          />
        ) : null}
        <div style={{ breakAfter: true }}>
          <Legend
            fieldDefinition={fields[this.props.pathContext.dataField]}
            location={this.props.location.pathname}
          >
            <input
              type="checkbox"
              defaultChecked={this.state.showKoop}
              onChange={event => {
                this.setState({ showKoop: event.target.checked })
              }}
            />Kooperationen anzeigen
          </Legend>
          <div className="content-map-div">
            <Atlas
              getData={this.getData}
              field={this.props.pathContext.dataField}
              fieldDefinition={fields[this.props.pathContext.dataField]}
              zoomToIso={this.state.zoomToIso}
              setZoomToIso={this.setZoomToIso}
              clickOnGemeinde={this.clickOnGemeinde}
              overlay={this.state.showKoop && this.overlay}
            />
          </div>
        </div>
        {this.props.location.pathname.match('.*Nachmittagsbetreuung') ? (
          <Quelle>
            Quelle: Amt der Burgenländischen Landesregierung,
            Kindertagesheimstatistik {this.props.pathContext.year};
            Schulstatistik {this.props.pathContext.year}; Gemeindekooperationen:
            telefonische Erhebung bei den Gemeindeämtern (Oktober 2017)
          </Quelle>
        ) : (
          <Quelle>
            Quelle: Amt der Burgenländischen Landesregierung,
            Kindertagesheimstatistik {this.props.pathContext.year};
            Gemeindekooperationen: telefonische Erhebung bei den Gemeindeämtern
            (Oktober 2017)
          </Quelle>
        )}
      </div>
    )
  }
}

export default Criteria



// WEBPACK FOOTER //
// ./src/templates/criteria.js